import React, { useEffect } from "react";

import { useShopifyCart } from "@app/scripts/react-hooks/shopify";
import { CartFreeShipping } from "@app/scripts/react-cart/components/CartFreeShipping";
import { CartItems } from "@app/scripts/react-cart/components/CartItems";
import { CartOrderSummary } from "@app/scripts/react-cart/components/CartOrderSummary";

import type { GiftProduct } from "@app/scripts/types";

type Props = {
  additionalCheckout?: string | null;
  freeShipping?: number;
  giftProduct?: GiftProduct;
  lowStockThreshold: number;
};

export const CartMain: React.FC<Props> = ({ freeShipping, additionalCheckout, giftProduct, lowStockThreshold }) => {
  const {
    products,
    cart,
    fetchCart,
    goToCheckout,
    handleUpdate,
    totalDiscount,
    addOosVariant,
    cartTotal,
    giftId,
    giftMessage,
    cartBeforeDiscountPrice,
  } = useShopifyCart({ giftProduct });

  useEffect(() => {
    fetchCart();
  }, []);

  return (
    <>
      <div className="cart-main__inner">
        <div className="hide-desktop">
          <CartFreeShipping cart={cart} freeShipping={freeShipping} />
        </div>

        <div className="cart-main__left">
          <CartItems
            cart={cart}
            products={products}
            handleUpdate={handleUpdate}
            addOosVariant={addOosVariant}
            giftId={giftId}
            giftMessage={giftMessage}
            lowStockThreshold={lowStockThreshold}
            notifyLabel="Notify Me When Available"
          />
        </div>

        <div className="cart-main__right">
          <div className="hide-mobile">
            <CartFreeShipping cart={cart} freeShipping={freeShipping} />
          </div>

          <CartOrderSummary
            totalDiscount={totalDiscount}
            cart={cart}
            goToCheckout={goToCheckout}
            cartTotal={cartTotal}
            additionalCheckout={additionalCheckout}
            view="cart_page"
            cartBeforeDiscountPrice={cartBeforeDiscountPrice}
          />
        </div>
      </div>
    </>
  );
};
